import { Text, TruncatedContent } from "@aurem/ui";
import { useGlobalSearchContext } from "../context";
import { SearchCompany } from "../types";
import { SearchItemWrapper } from "./SearchItemWrapper";

type Props = {
  company: SearchCompany;
};

export const CompanySearchItem = ({ company }: Props) => {
  const { handleItemClick } = useGlobalSearchContext();

  return (
    <SearchItemWrapper
      className="flex gap-2"
      onClick={() => handleItemClick(company)}
    >
      <Text size="sm" className="shrink-0 whitespace-nowrap">
        {company.name}
      </Text>
      <TruncatedContent className="text-sm text-neutral-500/50">
        {company.registeredNumber}
      </TruncatedContent>
    </SearchItemWrapper>
  );
};
